import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const Header = () => {
    const adminAssetsUrl = `${process.env.PUBLIC_URL}/admin-assets`;
    const navigate = useNavigate();

    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    const handleLogout = (e) => {
        if (e) e.preventDefault();
        localStorage.removeItem('superAdminToken');
        localStorage.removeItem('superAdminInfo');
        navigate('/superadmin/login');
    };

    const adminInfoStr = localStorage.getItem('superAdminInfo');
    const adminInfo = adminInfoStr ? JSON.parse(adminInfoStr) : null;

    const toggleMenuBtn = () => {
        const windowSize = document.documentElement.clientWidth;
        const html = document.documentElement;
        const body = document.body;

        const hamburgerIcon = document.querySelector(".hamburger-icon");
        const topnavHamburger = document.getElementById("topnav-hamburger-icon");
        if (hamburgerIcon) hamburgerIcon.classList.toggle("open");
        if (topnavHamburger) topnavHamburger.classList.toggle("open");

        if (windowSize > 767) {
            const currentSize = html.getAttribute("data-sidebar-size");
            const newSize = currentSize === "sm" ? "lg" : "sm";
            html.setAttribute("data-sidebar-size", newSize);
            body.classList.remove("vertical-sidebar-enable"); 
        } else {
            body.classList.toggle("vertical-sidebar-enable");
            html.setAttribute("data-sidebar-size", "lg");
        }
    };

    return (
        <header id="page-topbar">
            <div className="layout-width">
                <div className="navbar-header">
                    <div className="d-flex">
                        <button 
                            type="button" 
                            className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none" 
                            id="topnav-hamburger-icon"
                            onClick={toggleMenuBtn}
                        >
                            <span className="hamburger-icon">
                                <span />
                                <span />
                                <span />
                            </span>
                        </button>
                    </div>
                    <div className="d-flex align-items-center">
                        <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                            <DropdownToggle tag="button" type="button" className="btn shadow-none">
                                <span className="d-flex align-items-center">
                                    <img className="rounded-circle header-profile-user" src={`${adminAssetsUrl}/images/users/avatar-1.jpg`} alt="Header Avatar" />
                                    <span className="text-start ms-xl-2">
                                        <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                                            {adminInfo ? adminInfo.name : 'SuperAdmin'}
                                        </span>
                                        <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                                            Admin
                                        </span>
                                    </span>
                                </span>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <h6 className="dropdown-header">Welcome {adminInfo ? adminInfo.name : 'SuperAdmin'}!</h6>
                                <div className="dropdown-divider"></div>
                                <DropdownItem onClick={handleLogout}>
                                    <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                                    <span className="align-middle" data-key="t-logout">Logout</span>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
